import { EditorModes, ReviewType } from "@buildwithflux/models";
import { PcbLayoutRuleCompiler } from "../../pcb";
import { getProblemTypeKeyFromReviewType } from "../types";
export class DeprecatedRulesValidator {
    reviewType = ReviewType.DesignRuleCheckDeprecatedRules;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems({ pcbLayoutRuleSets, pcbLayoutNodes }) {
        const deprecatedRulesUsages = new Map();
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.values(pcbLayoutRuleSets).forEach((ruleSet) => 
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.values(ruleSet.rules).forEach((rule) => {
            if (PcbLayoutRuleCompiler.isRuleDeprecated(rule)) {
                const record = deprecatedRulesUsages.get(rule.key) ?? [];
                record.push({ type: "ruleSet", uid: ruleSet.uid });
                deprecatedRulesUsages.set(rule.key, record);
            }
        }));
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.values(pcbLayoutNodes).forEach((node) => 
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.values(node.pcbNodeRuleSet).forEach((rule) => {
            if (PcbLayoutRuleCompiler.isRuleDeprecated(rule)) {
                const record = deprecatedRulesUsages.get(rule.key) ?? [];
                record.push({ type: "pcbLayoutNode", uid: node.uid });
                deprecatedRulesUsages.set(rule.key, record);
            }
        }));
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems: Array.from(deprecatedRulesUsages.entries()).map(([ruleKey, affectedItems]) => ({
                problemTypeKey: this.problemTypeKey,
                key: `${this.problemTypeKey}_${ruleKey}`,
                label: `${ruleKey} is deprecated`,
                affectedItems,
                affectedViews: [EditorModes.pcb],
            })),
        };
    }
}
//# sourceMappingURL=DeprecatedRulesValidator.js.map